(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/article-content-navigation"],{

/***/ "./src/assets/js/article-content-navigation.js":
/*!*****************************************************!*\
  !*** ./src/assets/js/article-content-navigation.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ArticleNavigationWidget = /*#__PURE__*/function (_HTMLElement) {
  function ArticleNavigationWidget() {
    var _this;
    _classCallCheck(this, ArticleNavigationWidget);
    _this = _callSuper(this, ArticleNavigationWidget);
    _this.markedTitles = [];
    _this.contentWrapper = _this.closest(".article-meta__main");
    _this.container = _this.querySelector('.article-content-navigation__content');
    _this.prevActiveTitle = null;
    _this.headerHeight = 100;
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }
  _inherits(ArticleNavigationWidget, _HTMLElement);
  return _createClass(ArticleNavigationWidget, [{
    key: "changeActiveLink",
    value: function changeActiveLink(title) {
      var targetLink = this.querySelector("[data-target=\"".concat(title.getAttribute('name'), "\"]")).closest('li');
      var activeLink = this.querySelector("li.active");
      if (activeLink) {
        activeLink.classList.remove('active');
      }
      targetLink.classList.add('active');
      this.prevActiveTitle = title;
    }
  }, {
    key: "initObserver",
    value: function initObserver(title) {
      var _this2 = this;
      var options = {
        root: null,
        rootMargin: "-".concat(this.headerHeight, "px 0px"),
        threshold: 0.5
      };
      var callback = function callback(entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            _this2.changeActiveLink(entry.target);
          }
        });
      };
      var observer = new IntersectionObserver(callback, options);
      observer.observe(title);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var scrollPosition = window.scrollY + this.headerHeight;
      var activeTitle = null;
      var _iterator = _createForOfIteratorHelper(this.markedTitles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var title = _step.value;
          var titlePosition = title.getBoundingClientRect().top + window.scrollY;
          if (titlePosition - this.headerHeight <= scrollPosition) {
            activeTitle = title;
          } else {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (activeTitle && activeTitle !== this.prevActiveTitle) {
        this.changeActiveLink(activeTitle);
      }
    }
  }, {
    key: "scrollToTitle",
    value: function scrollToTitle(event) {
      event.preventDefault();
      var targetName = event.target.getAttribute("href").substring(1);
      var target = document.querySelector("[name=\"".concat(targetName, "\"]"));
      if (target) {
        var scrollOffsetTop = target.getBoundingClientRect().top + window.scrollY - this.headerHeight;
        window.scrollTo({
          top: scrollOffsetTop,
          behavior: "smooth"
        });
      }
    }
  }, {
    key: "createLink",
    value: function createLink(title) {
      var _this3 = this;
      var linkWrapper = document.createElement('li');
      var link = document.createElement('a');
      link.classList.add("article-content-navigation__content__link");
      link.setAttribute('data-target', title.getAttribute('name'));
      link.href = "#".concat(title.getAttribute('name'));
      link.textContent = title.textContent;
      link.addEventListener('click', function (event) {
        return _this3.scrollToTitle(event);
      });
      linkWrapper.appendChild(link);
      return linkWrapper;
    }
  }, {
    key: "insertLink",
    value: function insertLink(link) {
      this.container.appendChild(link);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      document.addEventListener('DOMContentLoaded', function () {
        var allTitles = _this4.contentWrapper.querySelectorAll('h4');
        if (allTitles.length) {
          allTitles.forEach(function (title, index) {
            var isInsideTextComponent = title.closest('.text-component');
            if (isInsideTextComponent && isInsideTextComponent.hasAttribute('data-hide')) {
              return;
            }
            if (!title.hasAttribute('data-hide')) {
              var id = "NavigationTitle-".concat(index);
              title.setAttribute('name', id);
              var readyLink = _this4.createLink(title);
              _this4.insertLink(readyLink);
              _this4.initObserver(title);
            }
          });
        }
        var textComponents = _this4.contentWrapper.querySelectorAll('.text-component');
        textComponents.forEach(function (textComponent) {
          var titleElement = textComponent.querySelector('h4');
          var navigationWrapper = textComponent.querySelector('.article-content-navigation');
          var otherElements = textComponent.querySelectorAll('p, img, ul, ol');
          var hasContent = false;
          otherElements.forEach(function (element) {
            if (element && element.textContent.trim() !== '') {
              hasContent = true;
            }
          });
          if (titleElement && hasContent) {
            if (navigationWrapper) {
              navigationWrapper.classList.add('show-navigation');
            }
          } else {
            if (navigationWrapper) {
              navigationWrapper.classList.add('hide-navigation');
            }
          }
        });
        window.addEventListener('scroll', _this4.handleScroll);
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (customElements.get('article-navigation') === undefined) {
  customElements.define("article-navigation", ArticleNavigationWidget);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/article-content-navigation.js"));
/******/ }
]);